module.exports = __webpack_public_path__ + "static/img/manual-30.3089458.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-30.png
// module id = 5Tg6
// module chunks = 4